<template>
  <section class="node">
    <Broadcasts
      v-if="decisionTree.currentBroadcastsFromPreviousNodes.length"
      class="node__broadcasts --previous"
      :broadcasts="decisionTree.currentBroadcastsFromPreviousNodes"
    />
    <header class="node__header">
      <slot name="header" />
    </header>
    <div class="node__body">
      <slot name="body" />
    </div>
    <Broadcasts
      v-if="decisionTree.currentBroadcastsFromReachableNodes.length"
      class="node__broadcasts --reachable"
      :broadcasts="decisionTree.currentBroadcastsFromReachableNodes"
    />
  </section>
</template>

<script setup>
import Broadcasts from "#/decision_tree_viewer/components/Broadcasts.vue";

defineProps({
  node: {
    type: Object,
    required: true,
  },
  decisionTree: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.node__header {
  padding-top: var(--sp-comp-dtv-node-title-padding-top, 0);
  padding-bottom: var(--sp-comp-dtv-node-title-padding-bottom, 0);

  &,
  &:deep(*) {
    font: var(--sp-comp-dtv-node-title-font, var(--dtv-node-title-font, var(--sp-sys-typescale-h2-short)));
    text-align: var(--sp-comp-dtv-node-title-text-align, center);
    color: var(--sp-comp-dtv-node-title-color, var(--sp-sys-color-on-surface, #333));
  }
}

.node__body {
  font: var(--sp-comp-dtv-node-text-font, var(--sp-sys-typescale-body-short));
  margin-top: var(--sp-comp-dtv-node-body-margin-top, 1.5rem);

  &:deep(> * + *) {
    margin-top: var(--sp-comp-dtv-node-body-item-vertical-space, 0.5rem);
  }
}
.node:deep(.node__description) {
  margin-top: 0;
  padding: var(--sp-comp-dtv-node-description-padding, 0);

  &,
  * {
    color: var(--sp-comp-dtv-node-description-color, #999);
    font-size: var(--sp-comp-dtv-node-description-font-size, 0.875rem);
    font-weight: var(--sp-comp-dtv-node-description-font-weight, 400);
    line-height: var(--sp-comp-dtv-node-description-line-height, 1.2);
  }
}
.broadcasts.node__broadcasts + .node__header {
  margin-top: 2rem;
}
.broadcasts.node__broadcasts {
  &.--previous {
    margin-top: 0;
  }
}
</style>
